"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "trecchina": {
    "39e77b94": [{
      "hkey": "98c28c47",
      "slug": "parrutta-piano-dei-peri",
      "name": "Parrutta-Piano dei Peri",
      "primary": true,
      "skipSearch": false
    }],
    "parrutta": [{
      "hkey": "98c28c47",
      "slug": "parrutta-piano-dei-peri",
      "name": "Parrutta-Piano dei Peri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f26443ac": [{
      "hkey": "98c28c47",
      "slug": "parrutta-piano-dei-peri",
      "name": "Parrutta-Piano dei Peri",
      "primary": true,
      "skipSearch": false
    }],
    "piano-dei-peri": [{
      "hkey": "98c28c47",
      "slug": "parrutta-piano-dei-peri",
      "name": "Parrutta-Piano dei Peri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "trecchina"
    }]
  }
};
exports["default"] = _default;